// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2bdZd","empty":"ModalGraph_empty__1S9QE"};